import React, { useState, useEffect, useRef } from "react";
import MDBox from "components/MDBox";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Slide16 from "assets/images/TheSolutionImages/Slide1/Slide16.png";

function Slide3() {
  const [showScrollIcon, setShowScrollIcon] = useState(false);
  const scrollRef = useRef();

  useEffect(() => {
    const handleResize = () => {
      const isSmallScreen = window.innerWidth < 1300;

      const isIpadProLandscape =
        window.innerWidth >= 1350 &&
        window.innerWidth <= 1370 &&
        window.innerHeight >= 1000 &&
        window.innerHeight <= 1050;

      setShowScrollIcon(isSmallScreen || isIpadProLandscape);
    };

    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <MDBox textAlign="left" px={{ xs: 2, md: 4 }} width="100%">
      <MDBox
        width="100%"
        maxWidth={{ xs: "100%", md: "95%", lg: "1320px" }}
        height={{ xs: "auto", md: "540px" }}
        margin="0 auto"
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="space-between"
        gap={4}
        px={{ xs: 2, md: 3 }}
        py={3}
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0)",
          borderRadius: "12px",
          color: "#FFFFFF",
          "*": {
            color: "#FFFFFF !important",
          },
        }}
      >
        {/* Left - Scrollable Text */}
        <MDBox
          flex="1"
          display="flex"
          flexDirection="column"
          height="100%"
          maxHeight="100%"
          pr={1}
          justifyContent="flex-start"
        >
          <h1
            style={{
              fontSize: "clamp(24px, 5vw, 32px)",
              fontWeight: "bold",
              marginBottom: "16px",
            }}
          >
            What is SharpWatch®
          </h1>

          <MDBox
            ref={scrollRef}
            fontSize={{ xs: "18px", md: "24px" }}
            lineHeight={1.6}
            sx={{
              overflowY: "auto",
              maxHeight: { xs: "300px", md: "none" },
              pr: 1,
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <ul style={{ listStyleType: "none", paddingLeft: "20px", fontSize: "24px" }}>
              <li style={{ marginBottom: "12px" }}>
                <strong>SharpWatch® is a Real-Time Condition Monitoring Platform</strong>
                <ul
                  style={{
                    listStyleType: "circle",
                    paddingLeft: "20px",
                    marginTop: "8px",
                    fontSize: "20px",
                  }}
                >
                  <li>Hosts an assortment of software modules for specific diagnostic functions</li>
                  <li>Built-in alarm and event logs</li>
                  <li>Has simulation capability and real-time playback for offline tuning</li>
                  <li>Built-in historian operability and cloud connectivity</li>
                  <li>
                    {
                      "Tracks operator interaction and response metrics via KPI's for ops efficiency"
                    }
                  </li>
                </ul>
              </li>
              <li>
                <strong>SharpWatch® SSLD Modules include</strong>
                <ul
                  style={{
                    listStyleType: "circle",
                    paddingLeft: "20px",
                    marginTop: "8px",
                    fontSize: "20px",
                  }}
                >
                  <li>(CROC)</li>
                  <li>(CTNA) — Patented US 12,158,397</li>
                  <li>(TTM) – Patented US 12,297,917</li>
                  <li>(MIMO)</li>
                  <li>Hydrostatic Module</li>
                </ul>
              </li>
            </ul>
          </MDBox>

          {/* Scroll icon (OUTSIDE of scrollable area) */}
          {showScrollIcon && (
            <MDBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              mt={2}
              sx={{
                animation: "bounce 1.5s infinite",
                fontSize: "30px",
                color: "#FFFFFF",
              }}
            >
              <KeyboardArrowDownIcon fontSize="inherit" />
            </MDBox>
          )}
        </MDBox>

        {/* Right - Image */}
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={{ xs: "100%", md: "40%" }}
          maxWidth={{ xs: "100%", md: "400px" }}
        >
          <img
            src={Slide16}
            alt="SharpWatch Logo"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "16px",
              objectFit: "contain",
            }}
          />
        </MDBox>
      </MDBox>

      {/* Bounce Animation */}
      <style>
        {`
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(6px); }
          }
        `}
      </style>
    </MDBox>
  );
}

export default Slide3;
